import { render } from "./PlaylistTable.vue?vue&type=template&id=08da4ba2"
import script from "./PlaylistTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Playlist/PlaylistTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08da4ba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08da4ba2', __exports__)) {
    api.reload('08da4ba2', __exports__)
  }
  
  module.hot.accept("./PlaylistTable.vue?vue&type=template&id=08da4ba2", () => {
    api.rerender('08da4ba2', render)
  })

}


export default __exports__